import React from 'react';
import { KebabButtonProps } from '../kebabmenu.model';
import { IconButton } from '@ui/buttons';

const KebabButton: React.FC<KebabButtonProps> = ({
  disabled,
  verticalIcon,
  sx,
  hidden,
  onClick,
  'aria-label': ariaLabel,
}) => (
  <IconButton
    category="mui"
    icon={verticalIcon ? 'MoreVert' : 'MoreHoriz'}
    disabled={disabled}
    hidden={hidden}
    aria-label={ariaLabel}
    onClick={onClick}
    sx={sx ?? {}}
  />
);

export default KebabButton;
